import type { GuidanceRow } from '../../customersuccess/framework';

type Props = { items?: GuidanceRow[] };

export function InteractiveGuidancePanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.title} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-xs font-medium text-brand-600">{item.feature}</p>
            <p className="mt-0.5 text-sm font-medium">{item.title}</p>
          </div>
          <p className="shrink-0 text-sm text-slate-500">{item.complete}/{item.users} complete</p>
        </div>
      ))}
    </div>
  );
}
